export const domainEnvironment = {
  //   coreImg: 'http://core.localhost.com/image?path=',
  rocketChatUrl: 'https://meet.offconon.com',
  rocketChatSocket: 'wss://meet.offconon.com/websocket',
  discordWebhookUrl:
    'https://discord.com/api/webhooks/1444299545499668541/jFQ6objpQcfvwuqAOr9CUPaZj0wB5AB1DJ-QY97AfazbP0kQR8Drip_bhIotO6BCbLUQ',
};
